import {useReducer} from "react";
import reducer, {ActionType, LOCAL_STORAGE_KEY} from "./reducer";
import initialState from "./state"

const UseYokohamaData = () => {

    const [state, dispatch] = useReducer(reducer, localStorage.getItem(LOCAL_STORAGE_KEY) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) : initialState)

    const setSelectedTree = value => dispatch({type: ActionType.SetSelectedTree, value})

    return {
        state,
        setSelectedTree,
    }
}

export default UseYokohamaData
